export default __webpack_public_path__ + "static/media/77634202551809989760654462161021701457269602020616730708810869957824872492.gif.2b5b6dcd.mp4";